import React, { useState, useEffect, useRef } from 'react';

import createStyle from 'shared-utils/src/createStyle';

import styles, { mainCls } from './style';

const useStyles = createStyle(styles);

export default function Strip({
  className,
  uri,
  goToPDP,
  children }) {
  const cls = useStyles();

  const text = useRef(null);

  const [expanded, setExpanded] = useState(false);
  useEffect(() => {
    const { current: textEl } = text;
    if (textEl.scrollHeight === textEl.clientHeight) {
      setExpanded(true);      
    } else {
      textEl.style.maxHeight = '18px';
    }
  }, []);

  const handleClick = (e) => {    
    if (!expanded) {
      e.preventDefault();
      const { current: textEl } = text;
      textEl.style.maxHeight = '36px';
      setExpanded(true);
    } else {
      goToPDP({ e });
    }
  };

  const rightCLick = (e) => goToPDP({ e, rightClick: true });

  return (
    <a
      href={uri}
      className={`${cls[mainCls]} ${className} pt--s pr--ms pb--s pl--ms is-clickable`}
      onClick={handleClick}
      onContextMenu={rightCLick}
    >
      <p
        ref={text}
        className={`${cls[`${mainCls}__p`]} tp-s--s tp-w--s c-txt--f0${expanded ? ' expanded' : ''}`}
      >
        {children}
      </p>
    </a>
  );
}